import { Reducer } from 'react';

import { IReportGroup } from 'services/reportGroupsService';
import { IReport } from 'services/reportsService';

export enum BITypes {
  SET_SCREEN = 'SET_SCREEN',
  TOGGLE_MENU = 'TOGGLE_MENU',
  SET_GROUP = 'SET_GROUP',
  SET_REPORT = 'SET_REPORT',
  SET_GROUPS = 'SET_GROUPS',
  SET_REPORT_CONFIG = 'SET_REPORT_CONFIG',
  SET_ISLOADING = 'SET_ISLOADING',
}

export interface BIState {
  isMobile?: boolean;
  showMenu: boolean;
  activeGroup?: IReportGroup;
  selectedReport?: IReport;
  avaliableReportGroups: IReportGroup[];
  embedUrl?: string;
  accessToken?: string;
  reportIsloading?: boolean;
}

const initialState: BIState = {
  isMobile: false,
  showMenu: false,
  activeGroup: undefined,
  selectedReport: undefined,
  avaliableReportGroups: [],
  embedUrl: '',
  accessToken: '',
  reportIsloading: false,
};

const reducer: Reducer<BIState, any> = (state, action) => {
  switch (action.type) {
    case BITypes.SET_SCREEN:
      return {
        ...state,
        isMobile: action.payload,
      };
    case BITypes.TOGGLE_MENU:
      return {
        ...state,
        showMenu: !state.showMenu,
      };
    case BITypes.SET_GROUP:
      return {
        ...state,
        activeGroup: action.payload,
      };
    case BITypes.SET_REPORT:
      return {
        ...state,
        selectedReport: action.payload,
      };
    case BITypes.SET_GROUPS:
      return {
        ...state,
        avaliableReportGroups: action.payload,
      };
    case BITypes.SET_REPORT_CONFIG:
      return {
        ...state,
        embedUrl: action.payload.embedUrl,
        accessToken: action.payload.accessToken,
      };
    case BITypes.SET_ISLOADING:
      return {
        ...state,
        reportIsloading: action.payload,
      };
    default:
      throw new Error('BI action not implemented');
  }
};

export { initialState };

export default reducer;
